import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import GearsSep from './components/GearsSep.vue'
import Carousel3d from 'vue-carousel-3d'
import VueLazyLoadVideo from 'vue-lazyload-video'
import Dropdown from 'vue-simple-search-dropdown'

// Register Components
// LazyVideo & LazyVideoAsGIF
Vue.use(VueLazyLoadVideo)
Vue.use(Carousel3d)
Vue.use(BootstrapVue)
Vue.use(Dropdown)

Vue.config.productionTip = false

new Vue({
  components: {
    GearsSep,
    Carousel3d,
    Dropdown
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
